import styled from '@emotion/styled';

export const StyledAuthForm = styled('div')(
  () => `
  width: 520px;
  background: #fff;
  overflow: hidden;
  border-radius: 4px;

  .content {
    padding: 60px 40px 30px;
  }
`,
);

export const StyledAuthFormHeader = styled('div')(
  () => `
  background: #233044;
  height: 85px;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    width: 92px;
    height: 32px;
    background: url(/logo.svg) no-repeat center center;
    background-size: cover;
  }
`,
);
